










import {
  Component, Mixins, VModel,
} from 'vue-property-decorator';
import FilePlayer from './FilePlayer.vue';
import MusicalTimeHandlingMixin from '../mixins/MusicalTimeHandlingMixin';

@Component({ components: { FilePlayer } })
export default class FilePlayerContainer
  extends Mixins(MusicalTimeHandlingMixin) {
  @VModel({ default: false })
  playing!: boolean;
}
